import type { ChangeEvent } from 'react';
import { FormattedMessage } from 'react-intl';

import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { iconExchangeAlt } from '@sorare/core/src/atoms/icons/system/iconExchangeAlt.ts';
import { BodyM } from '@sorare/core/src/atoms/typography';
import { Switch } from '@sorare/core/src/components/search/Switch';
import { useFacet } from '@sorare/core/src/contexts/graphql-search';
import { useEvents } from '@sorare/core/src/lib/events/useEvents';
import type { FilterWidget } from '@sorare/core/src/lib/filters';
import { TOGGLE_FILTERS } from '@sorare/core/src/lib/filters';

import { Toggle } from '#src/searchCards/Toggle/index.tsx';
import { ToggleFilter } from '#src/searchCards/ToggleFilter/index.tsx';

const FILTER = TOGGLE_FILTERS.onSaleFilter;

export const widget = ({
  startsOpen = true,
}: {
  startsOpen?: boolean;
} = {}): FilterWidget => ({
  key: FILTER.attribute,
  type: 'toggle',
  attribute: FILTER.attribute,
  Component: () => (
    <ToggleFilter
      icon={<FontAwesomeIcon icon={iconExchangeAlt} />}
      filter={FILTER}
    />
  ),
  accordionOptions: { startsOpen },
});

const BackendFilter = () => {
  const { refine } = useFacet('sale');

  const track = useEvents();
  const { value } = useFacet('sale');
  const isRefined = !!value.length;

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.checked;
    track('Use Market Filter', {
      filterName: FILTER.attribute,
      filterValue: newValue.toString(),
    });
    refine(() => (newValue ? ['true'] : []));
  };

  return (
    <Toggle icon={<FontAwesomeIcon icon={iconExchangeAlt} />}>
      <Switch
        checked={isRefined}
        onChange={handleChange}
        label={
          <BodyM bold>
            <FormattedMessage {...FILTER.label} />
          </BodyM>
        }
      />
    </Toggle>
  );
};

export const backendWidget = (): FilterWidget => ({
  key: `${FILTER.attribute}_backend`,
  type: 'toggle',
  attribute: FILTER.attribute,
  Component: BackendFilter,
});
